module.exports = __webpack_public_path__ + "img/en_flag.1d2953b4.svg";